import Component from "../../lib/component";
import { decimalCount } from "../../helpers/number";
import {getDebouncedFunction} from "../../helpers/debounce";

export const NumericPriceConfig = {
    componentTypeKey: 'NumericPrice',
    baseHtmlClass: 'numeric_price',
    selector: '.numeric_price',
};

export class NumericPrice extends Component {

    constructor(id_or_element) {
        super({
            element: id_or_element,
            config: NumericPriceConfig
        });

        // If the input is of type "text" then we change it to "number". This works around the old Formtastic gem which doesn't support the "number" type.
        if (isTextInput(this.element)) this.element.setAttribute('type', 'number');

        this.errors = [];

        const debouncedFunction = getDebouncedFunction(this.handleInputChange.bind(this), 300);
        this.element.addEventListener('keyup', debouncedFunction);

        this.render();
    }

    handleInputChange() {
        this.validate();
        this.render();
    }

    render() {
        this.swapHtmlClassStates(this.isValid(), 'valid', 'invalid');
    }

    validate() {
        this.errors = [];
        if (!this.hasValidDecimalCount()) this.addError({ key: 'DECIMAL_COUNT', message:'Prices will be rounded to two decimal places.' });
        return this.isValid();
    }

    getValue() {
        return this.element.value;
    }

    hasValue() {
        const value = this.getValue();
        return value !== '' && value !== null && typeof value !== 'undefined';
    }

    isValid() {
        return this.errors.length === 0;
    }

    addError(errorObj) {
        this.errors.push(errorObj);
        console.warn("[NumericPrice] addError() errorObj: ", errorObj);
    }

    hasValidDecimalCount() {
        if (!this.hasValue()) return true;
        const decimals = decimalCount(this.getValue());
        return (decimals >= 0 && decimals <= 2);
    }
}

function isTextInput(element) {
    const tagName = element.tagName || '';
    const type = element.getAttribute('type') || '';
    return tagName.toUpperCase() === 'INPUT' && type.toUpperCase() === 'TEXT';
}

